module.exports = __webpack_public_path__ + "img/icon_map_ymbz.e76c3f3e.png";